export const GTAX_HOST = true;

export const gx = (p = "") => p || "/";
